import { Api } from "../Api";
require('dotenv');
const axios = require('axios').default;

let GetAgreementInfoApi =
{
    endpoint: "AdobeSign/",

    async get(timesheetId) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + timesheetId;
        var response = {};

        try {
            response = await axios.get(URL, { withCredentials: true })
        }
        catch (e) {
            response.data = {}
            response.data.error = "Server or network error. Please refresh the page and contanct an adminstrator if this error persists. " + e.message;
        }
            

        return response.data;
    },

    async put(timesheetId) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + timesheetId;
        var response = {};

        try {
            response = await axios.put(URL, {}, { withCredentials: true })
        }
        catch (e) {
            response.data = {}
            response.data.error = "Server or network error. Please refresh the page and contanct an adminstrator if this error persists. " + e.message;
        }


        return response.data;
    }
}


export default GetAgreementInfoApi;
